import React from 'react';
import Particles from 'react-particles-js';

import Layout from '../components/Layout';
import Scroll from '../components/Scroll';

import config from '../../config';
import Footer from '../components/Footer';
import SocialLinks from '../components/SocialLinks';
import Subscribe from '../components/Subscribe';
import Header from '../components/Header';

import demoImage1 from '../assets/images/demo-image-01.jpg';
import demoImage2 from '../assets/images/demo-image-02.jpg';
import bgMaster from '../assets/images/bg-masthead.jpg';

const IndexPage = () => (
  <Layout>  
    <Particles 
      style={{ position: "absolute", zIndex: '1' }}
      params = {{
          particles: {
            number: {
              value: 120,
            },
            color: {
              value: "#000"
            },
            shape: {
              type: "star"
            },
          },
          interactivity: {
            events: {
              onclick: {
                enable: true,
                mode: "repulse"        
              },
              onhover: {
                enable: true,
                mode: "repulse"
              }
            }
          }
      }}
    />
    <Header />

    <header className="masthead">
      <div className="container d-flex h-100 align-items-center">
        <div className="mx-auto text-center">
          <h1 className="mx-auto my-0 text-uppercase">{config.heading}</h1>
          <h2 className="text-white-50 mx-auto mb-5">
            {config.subHeading}
          </h2>
          <Scroll type="id" element="about">
            <a href="#about" className="btn btn-primary">
              About
            </a>
          </Scroll>
        </div>
      </div>
    </header>

    <section id="about" className="about-section text-center">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <h2 className="text-white mb-4" style={{ fontSize: 35 }}>A proffessional Programmer</h2>
            <p className="text-white" style={{ fontSize: 20 }}>
                Full Stack developer with a demonstrated history of working in the computer software industry. Skilled in Firebase, Vue.js, HTML, JavaScript, React.js and Node.js. Strong engineering professional with a Engineer's Degree focused in High School/Secondary Diploma Programs from sri venkateswara college of engineering 
            </p>
          </div>
        </div>
        {/* <img src={ipad} className="img-fluid" alt="" /> */}
      </div>
    </section>


    <section id="projects" className="projects-section bg-light">
      <div className="container">
        <div className="row align-items-center no-gutters mb-4 mb-lg-5">
          <div className="col-xl-8 col-lg-7">
            <img className="img-fluid mb-3 mb-lg-0" src={bgMaster} alt="" />
          </div>
          <div className="col-xl-4 col-lg-5">
            <div className="featured-text text-center text-lg-left">
              <h4>Actchain oil and gas</h4>
              <p className="text-black-50 mb-0">
                Project 1
              </p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center no-gutters mb-5 mb-lg-0">
          <div className="col-lg-6">
            <img className="img-fluid" src={demoImage1} alt="" />
          </div>
          <div className="col-lg-6">
            <div className="bg-black text-center h-100 project">
              <div className="d-flex h-100">
                <div className="project-text w-100 my-auto text-center text-lg-left">
                  <h4 className="text-white">Just something</h4>
                  <p className="mb-0 text-white-50">
                    Project 2 
                  </p>
                  <hr className="d-none d-lg-block mb-0 ml-0" />
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="row justify-content-center no-gutters">
          <div className="col-lg-6">
            <img className="img-fluid" src={demoImage2} alt="" />
          </div>
          <div className="col-lg-6 order-lg-first">
            <div className="bg-black text-center h-100 project">
              <div className="d-flex h-100">
                <div className="project-text w-100 my-auto text-center text-lg-right">
                  <h4 className="text-white">Mountains</h4>
                  <p className="mb-0 text-white-50">
                      Project 3
                  </p>
                  <hr className="d-none d-lg-block mb-0 mr-0" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>


    <section id="skills" className="about-section mb-3">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <div className="mb-3 text-center">
              <button className="btn btn-primary" style={{ backgroundImage: 'linear-gradient(to right bottom, #430089, #82ffa1)', fontSize:16, cursor: "default"  }}>Skills</button>
            </div>
            <h4 style={{ color: "#fff" }}>React Js</h4>
            <div class="progress">
              <div class="progress-bar bg-success" role="progressbar" style={{width: 600}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">80%</div>
            </div>
            <br />
            <h4 style={{ color: "#fff" }}>Vue Js</h4>
            <div class="progress">
              <div class="progress-bar bg-success" role="progressbar" style={{width: 400}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">60%</div>
            </div>
            <br />
            <h4 style={{ color: "#fff" }}>Node Js</h4>
            <div class="progress">
              <div class="progress-bar bg-success" role="progressbar" style={{width: 500}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">70%</div>
            </div>
            <br />
            <h4 style={{ color: "#fff" }}>MongoDB</h4>
            <div class="progress mb-5">
              <div class="progress-bar bg-success" role="progressbar" style={{width: 300}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">50%</div>
            </div>
          </div>
          
        </div>
        {/* <img src={ipad} className="img-fluid" alt="" /> */}
      </div>
    </section>

    <Subscribe />

    <SocialLinks />
    <Footer />
  </Layout>
);

export default IndexPage;
